import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/custom-styles.css'
import {RouterProvider} from 'react-router-dom'
import {cbr_router} from './routes'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RouterProvider
      router={cbr_router}
      fallbackElement={
        <div className='w-full min-h-screen text-center flex justify-center items-center text-[#333333] bg-little-gray'>
          Loading...
        </div>
      }
    />
  </React.StrictMode>
)
